'use strict';

import { merge } from 'lodash';
import df from 'deep-freeze';

import sharedConfig from './shared-config';

//% ============================================
//% Final export
//% ============================================
/*
 * Minimal client-config overlays (e.g. only `admin`) omit sibling keys after merge.
 * Fill template minimums first; dev defaults + sharedConfig still win when present.
 */
const merged = merge({
    admin: {
        defaultEventTime: '18:00',
        showArchivedToggle: true,
    },
    debug: {
        level: 'info',
    },
    storefront: {
        showDevUi: false,
    },
}, sharedConfig);

export default df(merge({
    admin: {
        defaultEventTime: '',
        showArchivedToggle: false,
    },
    debug: {
        level: '',
    },
    storefront: {
        showDevUi: false,
    },
}, merged));
